import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { headerStyle, cellStyle } from '../../../../utils/configTable';

const OrganizationListTable = ({ data, orgCertStatusUpdate }) => {


    const formatCell = (cell, row) => {
        return cell == 1 ? '✔' : ''
    }

    const onClick = (e, col, colIndex, row, rowIndex) => {
        e.stopPropagation()
        const payload = {
            idOrg: row.idOrganization,
            value: row.dig_certification == 1 ? -1 : 1
        }
        orgCertStatusUpdate(payload)
    }

    const columns = [
        {
            dataField: 'id',
            text: '',
            headerStyle: headerStyle(5),
            style: cellStyle(),
            formatter: (cell, row, rowIndex) => rowIndex + 1
        },
        {
            dataField: 'orgName',
            text: 'Образовательные организации',
            headerStyle: headerStyle(),
        },
        {
            dataField: 'checkbox',
            text: 'Аттестация педагогических сотрудников',
            headerStyle: headerStyle(10),
            formatter: (cell, row) => (
                <input type="checkbox" checked={row.dig_certification == 1}/>
            ),
            style: {cursor: 'pointer'},
            events: {onClick}
        }
    ];

    return (
        <BootstrapTable
            keyField='orgName'
            data={data}
            columns={columns}
            striped
            bootstrap4
        />
    )
};

export default OrganizationListTable